import { render, staticRenderFns } from "./middleBottom.vue?vue&type=template&id=0d11abed&scoped=true&"
import script from "./middleBottom.vue?vue&type=script&lang=js&"
export * from "./middleBottom.vue?vue&type=script&lang=js&"
import style0 from "./middleBottom.vue?vue&type=style&index=0&id=0d11abed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d11abed",
  null
  
)

export default component.exports